export const FIND_MODULE_REQUEST = 'FIND_MODULE_REQUEST';

export const findModuleRequest = ( id ) => ({
    type: FIND_MODULE_REQUEST,
    payload: { id }
});
